/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'

import { useRouter } from 'next/router'

import { Listbox } from '@headlessui/react'

interface CategorySort {
  onChange: (e: { name: string; value: string | null }[]) => void
  className?: string
  classSelectButtonName?: string
  isError?: boolean | string
  isICon?: boolean
  selectContainClassName?: string
  sortOptions: any
  activeSort: any
  value?: any
  activeSortCustom: string[]
}

const CategorySort = ({
  sortOptions,
  onChange,
  className = '',
  activeSort = '',
  activeSortCustom = [''],
}: CategorySort) => {
  const router = useRouter()
  const [, setIsSelected] = useState(false)
  const [selectedValue, setSelectedValue] = useState<string[]>([])

  const sortOptionsData = sortOptions
    .filter((e: any) => e.type == 'custom')
    .map((item: any) => ({
      name: item.name,
      value: null,
    }))

  useEffect(() => {
    const checkSortActive = sortOptions
      .filter((e: any) => e.type == 'custom')
      .map((item: any) => {
        if (activeSortCustom.includes(item.name)) {
          return item
        }

        
return null
      })
      .filter(Boolean)

    setSelectedValue(checkSortActive)
  }, [])

  const onChangeSortCustom = (by: any) => {
    setSelectedValue(by)

    const updatedArray = sortOptionsData.map((item: any) => {
      const match = by.find((elem: any) => elem.name === item.name)

      if (!match) {
        return { ...item, value: null }
      }

      
return { ...item, value: true }
    })

    onChange(updatedArray)
    setIsSelected(true)
  }

  useEffect(() => {
    if (activeSort) {
      return setActiveSortButton(activeSort)
    }

    
return setActiveSortButton('')
  }, [activeSort, router])

  const onPriceSort = (name: string) => {
    setActiveSortButton(name)

    if (name == activeSortButton) {
      setActiveSortButton('')
      
return onChange([
        {
          name: 'sortBy',
          value: null,
        },
        {
          name: 'sortType',
          value: null,
        },
      ])
    }

    
return onChange([
      {
        name: 'sortBy',
        value: 'calMediaPrice',
      },
      {
        name: 'sortType',
        value: name,
      },
    ])
  }

  const [activeSortButton, setActiveSortButton] = useState('')

  
return (
    <div
      className={`relative flex items-center gap-2 text-[13px] ${className}`}
    >
      <Listbox
        as='div'
        value={selectedValue}
        onChange={onChangeSortCustom}
        horizontal
        multiple
      >
        <Listbox.Options className={`flex gap-2`} as='div' static>
          {sortOptions &&
            sortOptions
              .filter(
                (item: { name: string; label: string; type: string }) =>
                  item.type == 'custom'
              )
              .map((e: any, index: number) => (
                <Listbox.Option
                  key={`sort-${index}`}
                  as='div'
                  className={``}
                  value={e}
                >
                  <div
                    className={`flex h-9 cursor-pointer items-center gap-1 rounded-lg border px-2 ${
                      e && e.name && activeSortCustom?.includes(e.name)
                        ? 'border-primary-base bg-pink-200 font-semibold text-primary-base'
                        : 'border-pink-200 bg-grey-1600'
                    }`}
                  >
                    {e.label}
                  </div>
                </Listbox.Option>
              ))}
        </Listbox.Options>
      </Listbox>

      <div className={`flex gap-2`}>
        {sortOptions &&
          sortOptions
            .filter((item: any) => item.type == 'sortType')
            .map((e: any, index: number) => (
              <button
                key={`sort-${index}`}
                className={``}
                onClick={() => onPriceSort(e.name)}
              >
                <div
                  className={`flex h-9 cursor-pointer items-center gap-1 rounded-lg border px-2 ${
                    activeSortButton == e.name
                      ? 'border-primary-base bg-pink-200 font-semibold text-primary-base'
                      : 'border-pink-200 bg-grey-1600'
                  }`}
                >
                  {e.label}
                </div>
              </button>
            ))}
      </div>
    </div>
  )
}

export default CategorySort
